import { Loader2 } from 'lucide-react';
const cannafaxLogo = "/cannafax-logo-clean.png";

type Variant = 'loading' | 'signing-in' | 'signing-out';

const MESSAGES: Record<Variant, string> = {
  loading: 'Getting your desk ready…',
  'signing-in': 'Signing you in…',
  'signing-out': 'Signing out…',
};

interface AuthLoadingSkeletonProps {
  variant?: Variant;
}

/**
 * Branded loading screen shown during auth transitions.
 * Replaces the generic skeleton with a friendly, human message.
 */
const AuthLoadingSkeleton = ({ variant = 'loading' }: AuthLoadingSkeletonProps) => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background">
      <img
        src={cannafaxLogo}
        alt="cannafax.ai"
        className="h-12 w-auto object-contain"
        width={200}
        height={48}
      />
      <div className="flex items-center gap-2.5 text-muted-foreground mt-8">
        <Loader2 className="h-5 w-5 animate-spin" />
        <span role="status" className="text-xl font-semibold">
          {MESSAGES[variant]}
        </span>
      </div>
    </div>
  );
};

export default AuthLoadingSkeleton;
